import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import {Box, SxProps, Typography} from '@mui/material';
import ArrIconButton from '../../../common/arr-icon-button/ArrIconButton';
import {ReactComponent as DeleteIcon} from '../../../../assets/images/delete-icon-small.svg';
import {ReactComponent as DragItemIcon} from '../../../../assets/images/drag-item-icon.svg';
import '../DataExportReport.scss';
import {JSX} from 'react';
import './ExportDataListItem.scss';

type ExportDataListProps = {
  id: string;
  label: string;
  onRemoveItem: (id: string) => void;
};
export function ExportDataListItem({
  id,
  label,
  onRemoveItem,
}: ExportDataListProps): JSX.Element {
  const {attributes, listeners, setNodeRef, transform, transition, isDragging} =
    useSortable({id});

  const selectedFieldItemSx: SxProps = {
    transform: CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    display: 'flex',
    py: 1,
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
  };

  return (
    <Box
      ref={setNodeRef}
      className="export-item"
      sx={selectedFieldItemSx}
      component="li"
      aria-label={`Export item ${label}`}
      data-testid={`export-item-${id}`}
    >
      <Box
        sx={{
          display: 'flex',
          boxSizing: 'border-box',
          gap: 1,
          justifyContent: 'space-between',
          alignItems: 'center',
          width: `calc(100% - 1.5rem)`,
        }}
      >
        <Box
          className="field-drag-handle"
          {...attributes}
          {...listeners}
          aria-label={`Drag handle for ${label}`}
          tabIndex={0}
        >
          <DragItemIcon />
        </Box>
        <Typography
          sx={{textAlign: 'start'}}
          title={label}
          className="export-item-label"
          data-testid={`export-data-list-item-label-${id}`}
        >
          {`${label}`}
        </Typography>
      </Box>
      <ArrIconButton
        ariaLabel={`Remove ${label} from export list`}
        icon={<DeleteIcon />}
        onClick={() => onRemoveItem(id)}
        testId={`export-data-list-item-icon-button-${id}`}
      />
    </Box>
  );
}
